// Admin bar entry point — runs on ALL WP admin pages
// Separate from the React settings page entry (src/main.tsx)
import Alpine from 'alpinejs'
import { createAdminBarController } from './controllers/adminBarController.js'

// Make admin bar controller available globally for Alpine.js
window.rpAdminBar = createAdminBarController

// Initialize Alpine.js for the admin bar
window.Alpine = Alpine
Alpine.start()
